/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AddressUpdate = {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  stateOrProvince?: string | undefined;
  postalCode?: string | undefined;
  country?: string | undefined;
};

/** @internal */
export const AddressUpdate$inboundSchema: z.ZodType<
  AddressUpdate,
  z.ZodTypeDef,
  unknown
> = z.object({
  addressLine1: z.string().optional(),
  addressLine2: z.string().optional(),
  city: z.string().optional(),
  stateOrProvince: z.string().optional(),
  postalCode: z.string().optional(),
  country: z.string().optional(),
});
/** @internal */
export type AddressUpdate$Outbound = {
  addressLine1?: string | undefined;
  addressLine2?: string | undefined;
  city?: string | undefined;
  stateOrProvince?: string | undefined;
  postalCode?: string | undefined;
  country?: string | undefined;
};

/** @internal */
export const AddressUpdate$outboundSchema: z.ZodType<
  AddressUpdate$Outbound,
  z.ZodTypeDef,
  AddressUpdate
> = z.object({
  addressLine1: z.string().optional(),
  addressLine2: z.string().optional(),
  city: z.string().optional(),
  stateOrProvince: z.string().optional(),
  postalCode: z.string().optional(),
  country: z.string().optional(),
});

export function addressUpdateToJSON(addressUpdate: AddressUpdate): string {
  return JSON.stringify(AddressUpdate$outboundSchema.parse(addressUpdate));
}
export function addressUpdateFromJSON(
  jsonString: string,
): SafeParseResult<AddressUpdate, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AddressUpdate$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AddressUpdate' from JSON`,
  );
}
